import { CommonModule, NgClass } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IonCard, IonCardContent, IonCol, IonIcon, IonRow } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import {
  EFreightForShipperStatus,
  getEmptyFreightBasicForShipper,
  IFreightBasicForShipper,
  IFreightVehicle,
} from '@okcargo-apps/shared-domain';
import { DateFnsModule } from 'ngx-date-fns';
import { PriceAcceptanceButtonsComponent } from '../price-acceptance-buttons/price-acceptance-buttons.component';

@Component({
  selector: 'lib-freight-shipper-card',
  templateUrl: './freight-shipper-card.component.html',
  styleUrls: ['./freight-shipper-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    NgClass,
    RouterLink,
    RouterLinkActive,
    IonIcon,
    IonCol,
    IonRow,
    IonCardContent,
    IonCard,
    DateFnsModule,
    TranslateModule,
    PriceAcceptanceButtonsComponent,
  ],
})
export class FreightShipperCardComponent {
  @Input()
  freight: IFreightBasicForShipper = getEmptyFreightBasicForShipper();

  public readonly EFreightStatus = EFreightForShipperStatus;

  // constructor() {}

  public printVehicles(vehicles: IFreightVehicle[]): string {
    const vehiclesArrayTxt: string[] = [];
    vehicles.forEach((vehicle) => {
      if (vehicle.plate !== undefined && vehicle.plate !== '') {
        vehiclesArrayTxt.push(vehicle.plate);
      }
    });
    return vehiclesArrayTxt.join(', ');
  }
}
